"use strict";
exports.__esModule = true;
exports.isViewportFull = exports.getPinsFromCache = exports.unionPinsUseMax = exports.unionPins = exports.viewportToKey = void 0;
var getId_1 = require("../renderer/getId");
var LayerDefinition_1 = require("../common/interface/LayerDefinition");
exports.viewportToKey = function (viewport, layerDefinition) {
    return "" + layerDefinition.find(function (it) { return it.zoom < viewport.zoom; }).level;
};
exports.unionPins = function (oldPins, newPins) {
    var oldPinsTable = {};
    oldPins.map(function (it) {
        oldPinsTable[getId_1.getPositionId(it)] = it;
    });
    var newPinsTable = {};
    newPins.map(function (it) {
        newPinsTable[getId_1.getPositionId(it)] = it;
    });
    Object.entries(newPinsTable).map(function (_a) {
        var k = _a[0], v = _a[1];
        oldPinsTable[k] = v;
    });
    return Object.values(oldPinsTable);
};
exports.unionPinsUseMax = function (oldPins, newPins) {
    var oldPinsTable = {};
    oldPins.map(function (it) {
        oldPinsTable[getId_1.getPositionId(it)] = it;
    });
    var newPinsTable = {};
    newPins.map(function (it) {
        newPinsTable[getId_1.getPositionId(it)] = it;
    });
    Object.entries(newPinsTable).map(function (_a) {
        var k = _a[0], v = _a[1];
        if (!oldPinsTable[k]) {
            oldPinsTable[k] = v;
        }
        else if (Number(v.value) > Number(oldPinsTable[k].value)) {
            oldPinsTable[k] = v;
        }
    });
    return Object.values(oldPinsTable);
};
exports.getPinsFromCache = function (cache, viewport, layerDefinition) {
    var cacheKey = exports.viewportToKey(viewport, layerDefinition);
    return cache[cacheKey] || [];
};
exports.isViewportFull = function (viewport, layerDefinition) {
    var key = exports.viewportToKey(viewport, layerDefinition);
    return key === "" + LayerDefinition_1.ZoomLevel.AREA || key === "" + LayerDefinition_1.ZoomLevel.DISTRICT;
};
